import React, { useState } from 'react'
import _, { find } from 'lodash';
import Toggle from 'react-toggle';
import { useTranslation } from 'react-i18next'

import SelectionEventVideoType from './SelectionEventVideoType'
import SelectionSoundType from './SelectionSoundType'
import InfoPop from '../../common/InfoPop'
import CustomButton from '../../CustomButton'
import CustomReactBootstrapSlider from '../../CustomReactBootstrapSlider'
import LabelTag from '../../dump/LabelTag'
import ModalDelete from '../modals/ModalDelete'

import { isInternalUser } from '../../helpers/constants'
import SoundPlayButton from "./SoundPlayButton";

const FleetConfigurationEvent = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.editProfile.fleetConfigurationEvent' });
	const { settingsType, user, configuration, configurationdv6, configurationdv7, event_types, setConfiguration, fillFormBoolean, fillFormInt, fillForm } = props
	const [showModalDMSSeatbeltToggle, setShowModalDMSSeatbeltToggle] = useState(false)

	const userRole = user.roles[0]
	const isDV6 = settingsType === 'dv6'
	const isDV4 = settingsType === 'dv4'
	const isDV7 = settingsType === 'dv7'
	const currentConfig = isDV6 ? configurationdv6 : isDV7 ? configurationdv7 : configuration
	const Sensor4 = find(currentConfig.Event.Sensor, o => o.index === 4);

	const dv6ADASSettings = [
		{ name: t('nameForwardCollision'), event_setting: 'ForwardCollision', event_type_name: 'dv6_forward_collision', description: t('descriptionForwardCollision') },
		{ name: t('nameHeadwayMonitoring'), event_setting: 'Headway', event_type_name: 'dv6_headway_monitoring', description: t('descriptionHeadwayMonitoring') },
		{ name: t('nameTailgating'), event_setting: 'FollowingDistance', event_type_name: 'dv6_following_distance', description: t('descriptionTailgating') },
	]

	const dv6DMSSettings = [
		{ name: t('nameDistraction'), event_setting: 'Distraction', event_type_name: 'dv6_distraction', description: t('descriptionDistraction'), voice_prompt_setting: 'System.Chimes.Distraction' },
		{ name: t('nameYawning'), event_setting: 'Yawning', event_type_name: 'dv6_yawning', description: t('descriptionYawning'), voice_prompt_setting: 'System.Chimes.Yawning' },
		{ name: t('nameDozing'), event_setting: 'Dozing', event_type_name: 'dv6_drowsiness', description: t('descriptionDozing'), voice_prompt_setting: 'System.Chimes.Drowsiness' },
		{ name: t('namePhoneUse'), event_setting: 'PhoneUse', event_type_name: 'dv6_phone_use', description: t('descriptionPhoneUse'), voice_prompt_setting: 'System.Chimes.PhoneUse' },
		{ name: t('nameSmoking'), event_setting: 'Smoking', event_type_name: 'dv6_smoking', description: t('descriptionSmoking'), voice_prompt_setting: 'System.Chimes.Smoking' },
		// { name: t('nameSeatbelt'), event_setting: 'Seatbelt', event_type_name: 'dv6_seatbelt', description: t('descriptionSeatbelt'), voice_prompt_setting: 'System.Chimes.Seatbelt', isInternal: true },
		{ name: t('nameSeatbelt'), event_setting: 'Seatbelt', event_type_name: 'dv6_seatbelt', description: t('descriptionSeatbelt'), voice_prompt_setting: 'System.Chimes.Seatbelt' },
	]

	const dv6SensitivitySettings = [
		{ name: t('nameHighG-Force'), event_setting: 'Accelerometer', event_type_name: 'dv6_fatal_gsensor', description: t('descriptionHighG-Force'), sliderObj: { id: 1, min: 1.0, max: 4.0, step: 0.1, name: "Event.Accelerometer.FatalThreshold.X" } },
		{ name: t('nameHarshBraking'), event_setting: 'HarshBraking', event_type_name: 'dv6_harsh_braking', description: t('descriptionHarshBraking'), sliderObj: { id: 2, min: 7, max: 17, step: 0.1, name: "Event.HarshBraking.Threshold" }, sublabel: t('sublabelHarshBraking') },
		{ name: t('nameHarshAcceleration'), event_setting: 'HarshAccel', event_type_name: 'dv6_harsh_accel', description: t('descriptionHarshAcceleration'), sliderObj: { id: 3, min: 7, max: 17, step: 0.1, name: "Event.HarshAccel.Threshold" }, sublabel: t('sublabelHarshAcceleration') },
	]

	const dv7ADASSettings = [
		{ name: t('nameForwardCollision'), event_setting: 'ForwardCollision', event_type_name: 'dv7_forward_collision', description: t('descriptionForwardCollision') },
		{ name: t('nameHeadwayMonitoring'), event_setting: 'Headway', event_type_name: 'dv7_headway_monitoring', description: t('descriptionHeadwayMonitoring') },
		{ name: t('nameTailgating'), event_setting: 'FollowingDistance', event_type_name: 'dv7_following_distance', description: t('descriptionTailgating') },
	]

	const dv7ADASSettingsPart2 = [
		{ name: t('Front_Vehicle_Start_Alert'), event_setting: 'FrontVehicleStart', event_type_name: 'dv7_front_vehicle_start', description: t('Front_Vehicle_Start_Alert_description'), voice_prompt_setting: 'System.Chimes.FrontVehicleStart' },
		{ name: t('Traffic_Light_Compliance_Warning'), event_setting: 'TrafficLightViolation', event_type_name: 'dv7_traffic_light_violation', description: t('Traffic_Light_Compliance_Warning_description'), voice_prompt_setting: 'System.Chimes.TrafficLightViolation', sliderObj: { id: 4, min: 0, max: 10, step: 0.1, name: "Event.Adas.TrafficLightViolation.Sensitivity", hideNumberField: true } },
		{ name: t('Stop_Sign_Compliance_Warning'), event_setting: 'StopSignViolation', event_type_name: 'dv7_stop_sign_violation', description: t('Stop_Sign_Compliance_Warning_description'), voice_prompt_setting: 'System.Chimes.StopSignViolation', sliderObj: { id: 4, min: 0, max: 10, step: 0.1, name: "Event.Adas.StopSignViolation.Sensitivity", hideNumberField: true } },
	]

	const blindSpotsSettings = {
		name: t('Blind_Spot_Detection_Warning'),
		description: t('Blind_Spot_Detection_Warning_description'),
		settings: [
			{
				name: (<><span>{t('urban')}</span>&nbsp;({t('vehicleSpeed')} &lt; 15 mph)</>),
				event_setting: 'BlindSpotWarning',
				event_sub_setting: 'Urban',
				event_type_name: 'dv7_blind_spot_warning_urban'
			},
			{
				name: (<><span>{t('standard')}</span>&nbsp;({t('vehicleSpeed')} &gt;= 15 mph)</>),
				event_setting: 'BlindSpotWarning',
				event_sub_setting: 'Standard',
				event_type_name: 'dv7_blind_spot_warning_standard'
			},
		]
	}

	const speedLimitSettings = {
		name: t('Speed_Limit_Sign_Detection'),
		description: t('Speed_Limit_Sign_Detection_description'),
		settings: [
			{
				name: (<><span>{t('lowSpeedingLabel')}</span>&nbsp;(+1 {t('to')} +5 mph PSL)</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'Low',
				event_type_name: 'dv7_speed_limit_violation_low'
			},
			{
				name: (<><span>{t('moderateSpeedingLabel')}</span>&nbsp;(+6 {t('to')} +10 mph PSL))</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'Moderate',
				event_type_name: 'dv7_speed_limit_violation_moderate'
			},
			{
				name: (<><span>{t('highSpeedingLabel')}</span>&nbsp;(+11 {t('to')} +15 mph PSL)</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'High',
				event_type_name: 'dv7_speed_limit_violation_high'
			},
			{
				name: (<><span>{t('severeSpeedingLabel')}</span>&nbsp;(&ge; +16 mph PSL)</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'Severe',
				event_type_name: 'dv7_speed_limit_violation_severe'
			},
		]
	}

	const dv7DMSSettings = [
		{ name: t('nameDistraction'), event_setting: 'Distraction', event_type_name: 'dv7_distraction', description: t('descriptionDistraction'), voice_prompt_setting: 'System.Chimes.Distraction' },
		{ name: t('nameYawning'), event_setting: 'Yawning', event_type_name: 'dv7_yawning', description: t('descriptionYawning'), voice_prompt_setting: 'System.Chimes.Yawning' },
		{ name: t('nameDozing'), event_setting: 'Dozing', event_type_name: 'dv7_drowsiness', description: t('descriptionDozing'), voice_prompt_setting: 'System.Chimes.Drowsiness' },
		{ name: t('namePhoneUse'), event_setting: 'PhoneUse', event_type_name: 'dv7_phone_use', description: t('descriptionPhoneUse'), voice_prompt_setting: 'System.Chimes.PhoneUse' },
		{ name: t('nameSmoking'), event_setting: 'Smoking', event_type_name: 'dv7_smoking', description: t('descriptionSmoking'), voice_prompt_setting: 'System.Chimes.Smoking' },
		{ name: t('nameSeatbelt'), event_setting: 'Seatbelt', event_type_name: 'dv7_seatbelt', description: t('descriptionSeatbelt'), voice_prompt_setting: 'System.Chimes.Seatbelt' },
	]

	const dv7SensitivitySettings = [
		{ name: t('nameHighG-Force'), event_setting: 'Accelerometer', event_type_name: 'dv7_fatal_gsensor', description: t('descriptionHighG-Force'), sliderObj: { id: 1, min: 1.0, max: 4.0, step: 0.1, name: "Event.Accelerometer.FatalThreshold.X" } },
		{ name: t('nameHarshBraking'), event_setting: 'HarshBraking', event_type_name: 'dv7_harsh_braking', description: t('descriptionHarshBraking'), sliderObj: { id: 2, min: 7, max: 17, step: 0.1, name: "Event.HarshBraking.Threshold" }, sublabel: t('sublabelHarshBraking') },
		{ name: t('nameHarshAcceleration'), event_setting: 'HarshAccel', event_type_name: 'dv7_harsh_accel', description: t('descriptionHarshAcceleration'), sliderObj: { id: 3, min: 7, max: 17, step: 0.1, name: "Event.HarshAccel.Threshold" }, sublabel: t('sublabelHarshAcceleration') },
		{ name: t('G-Sensor_Wake-Up'), event_setting: 'GSensorWakeUp', event_type_name: 'dv7_gsensor_wakeup', description: t('G-Sensor_Wake-Up_description'), sliderObj: { id: 4, min: 0, max: 10, step: 0.1, name: "Event.GSensorWakeUp.Sensitivity" } },
		{ name: t('Dangerous_Backing-Up_Alerts'), event_setting: 'BackUpWarning', event_type_name: 'dv7_backup_warning', description: t('Dangerous_Backing-Up_Alerts_description'), voice_prompt_setting: 'System.Chimes.BackUpWarning' },
	]

	const dv4ADASSettings = [
		{ name: t('nameLaneDepartureWarning'), event_setting: 'LaneDeparture', description: t('descriptionLaneDepartureWarning') },
		{ name: t('nameForwardCollisionWarning'), event_setting: 'ForwardCollision', description: t('descriptionForwardCollisionWarning') },
		{ name: t('namePedestrianCollisionWarning'), event_setting: 'Pedestrian', description: t('descriptionPedestrianCollisionWarning') },
	]

	const dv4DMSSettings = [
		{ name: t('nameDistractionDv4'), event_setting: 'Distraction', event_type_name: 'dv4_distraction', description: t('descriptionDistractionDv4') },
		{ name: t('nameDrowsiness/LookingDown'), event_setting: 'Dozing', event_type_name: 'dv4_drowsiness', description: t('descriptionDrowsiness/LookingDown') },
		{ name: t('namePhoneUse/HandtoHead'), event_setting: 'PhoneUse', event_type_name: 'dv4_phone_use', description: t('descriptionPhoneUse/HandtoHead') },
	]

	// const PotentialCh2Obstruction = [
	// 	{ title: t('titleNoPrompt'), value: '0', description: t('descriptionNoPrompt') },
	// 	{ title: t('titleOnePrompt'), value: '1', description: t('descriptionOnePrompt') },
	// 	{ title: t('titleContinuousPrompt'), value: '2', description: t('descriptionContinuousPrompt') },
	// ]

	let unit = 'mph'
	if (currentConfig.System.SpeedUnit === 2) {
		unit = 'kph'
	}

	const fillFormSensors = (e, idx) => {
		const { target } = e;
		const { name } = target;
		let value = target.value * 1;
		if (target.type === 'checkbox') {
			value = !!(target.checked);
		}
		else if (target.type === 'button') {
			value = target.value === 'true'
		}

		if (idx === 8) {
			currentConfig.Event.Sensor[4].SendToCloud = value;
			// setConfiguration({ configurationdv6 })
		}

		currentConfig.Event.Sensor = currentConfig.Event.Sensor.map((sensor, sidx) => {
			if (idx === sensor.index) {
				sensor[name] = value;
				return sensor;
			}

			return sensor;
		});

		if (isDV6) {
			setConfiguration({ configurationdv6: currentConfig });
		} else if (isDV7) {
			setConfiguration({ configurationdv7: currentConfig });
		} else {
			setConfiguration({ configuration: currentConfig });
		}

	}

	const getMinSpeedSlider = () => {
		const { configurationdv6 } = props
		let res = 32
		if (currentConfig.System.SpeedUnit === 1) {
			res = 20
		}
		return res
	}

	const getMaxSpeedSlider = () => {
		const { configurationdv6 } = props
		let res = 89
		if (currentConfig.System.SpeedUnit === 1) {
			res = 55
		}
		return res
	}

	const numberFormat = (argName, argValue = null) => {
		const { configurationdv6, configurationdv7 } = props

		const res = (configurationdv) => {
			let res = configurationdv.Event.Adas.Headway.SpeedThreshold
			if (currentConfig.System.SpeedUnit === 1) {
				res = Math.round((res / 1.609344) * 1e2) / 1e2
			}

			return +res.toFixed(0)
		}

		isDV6 && res(configurationdv6);
		isDV7 && res(configurationdv7);
	}

	const onMinimumSpeedChange = (e, currentConfigArg) => {
		// debugger
		// FWSD-5160
		let { setConfiguration } = props
		let value = e * 1

		const isMPH = currentConfig.System.SpeedUnit === 1;
		if (isMPH) value = Math.round((value * 1.609344) * 1e2) / 1e2;

		const obj = { target: { name: 'Event.Adas.Headway.SpeedUnit', value: isMPH ? "mph" : "kph" } };
		fillForm(obj, settingsType);
		let configurationdv = _.set(currentConfig, 'Event.Adas.Headway.SpeedThreshold', value)
		configurationdv = _.set(currentConfig, 'Event.Adas.FollowingDistance.SpeedThreshold', value)
		isDV6 && setConfiguration({ configurationdv6: configurationdv })
		isDV7 && setConfiguration({ configurationdv7: configurationdv })
	}

	const setEventTypes = (argTypeValue) => {
		setConfiguration({ event_types: { ...event_types, ...argTypeValue } })
	}

	const setSoundTypes = (event_setting, argTypeValue, event_sub_setting) => {
		if (event_setting === "ForwardCollision") {
			currentConfig.System.Chimes.ForwardCollision = !!+argTypeValue;
		} else if (event_setting === "SpeedLimitViolation" && event_sub_setting) {
			currentConfig.System.Chimes[event_setting][event_sub_setting] = +argTypeValue;
		} else if (event_setting !== "CameraObstruction") {
			currentConfig.System.Chimes[event_setting] = +argTypeValue;
		} else {
			currentConfig.System.Chimes.CameraObstruction.SoundType = +argTypeValue;
		}

		isDV6 && setConfiguration({ configurationdv6: currentConfig });
		isDV7 && setConfiguration({ configurationdv7: currentConfig });
	}

	const fillHighGForceFatalThreshold = (e) => {
		const value = e.target.value * 1

		currentConfig.Event.Accelerometer.FatalThreshold.X = value
		currentConfig.Event.Accelerometer.FatalThreshold.Y = value

		if (isDV6) {
			setConfiguration({ configurationdv6: currentConfig });
		}
		else if (isDV7) {
			setConfiguration({ configurationdv7: currentConfig });
		}
		else {
			setConfiguration({ configuration: currentConfig });
		}
	}

	const eventSensitivityRender = (argObject) => {
		const { id, min, max, step, name } = argObject
		// FWSD-6898
		const tooltipFormatter = (value) => {
			let res = value

			if (id !== 1) {
				res = (value * 0.28 / 9.81).toFixed(2)
			}

			return `${Math.abs(res)} Gs`
		}

		return (
			<div className="toggle-wrapper slider-wrapper">
				<label className="settings-title">{t('titleSensitivity')}</label>
				<div className="backlight-slider">
					<CustomReactBootstrapSlider
						name={name}
						max={max}
						min={min}
						step={step}
						tooltip="show"
						reversed={true}
						value={_.get(currentConfig, name, '')}
						formatter={tooltipFormatter}
						change={(e) => id === 1 ? fillHighGForceFatalThreshold(e) : fillFormInt(e, settingsType, name)} // FWSD-6903
					/>
					<InfoPop
						title={t('infoPopTitle')}
						body={t('infoPopBody')}
						placement='top'
					>
						<div className="temp-bar-container slider slider-horizontal mt-10">
							<div className="cold temp-bar">{t('tempBarLessSensitive')}</div>
							<div className="med temp-bar" />
							<div className="hot temp-bar">{t('tempBarMoreSensitive')}</div>
						</div>
					</InfoPop>
				</div>
			</div>
		)
	}

	const eventDistanceTimeRender = (argObject) => {
		const { id, min, max, step, name, hideNumberField } = argObject

		return (
			<div className="toggle-wrapper slider-wrapper block">
				<label className="settings-title mb-10">{t('titleFollowingDistanceTime')}</label>
				<div className="toggle-wrapper slider-wrapper p-0 no-border">
					<div className="backlight-slider mr-20">
						<CustomReactBootstrapSlider
							name={name}
							max={max}
							min={min}
							step={step}
							tooltip="show"
							value={_.get(currentConfig, name, '')}
							change={(e) => id === 1 ? fillHighGForceFatalThreshold(e) : fillFormInt(e, settingsType, name)}
						/>
						<InfoPop
							title={t('infoPopTitle')}
							body={t('infoPopBody')}
							placement='top'
						>
							<div className="temp-bar-container slider slider-horizontal mt-10">
								<div className="cold temp-bar">{t('tempBarLessSensitive')}</div>
								<div className="med temp-bar"/>
								<div className="hot temp-bar">{t('tempBarMoreSensitive')}</div>
							</div>
						</InfoPop>
					</div>
					{/* ToDo: Add support of min/max/step... for text field within refactoring */}
					{!hideNumberField ? (
						<div>
							<input
								type="number"
								step="0.1"
								min="0.1"
								max="3.0"
								maxLength="3"
								name="Event.Adas.Headway.Ttc.TriggerThreshold"
								value={currentConfig.Event.Adas.Headway.Ttc.TriggerThreshold}
								className="vehicle-search number-input mr-10 pt-5"
								onChange={(e) => fillForm(e, settingsType)}
							/>
							<label style={{marginLeft: '6px'}}>{t('textSeconds')}</label>
						</div>
					) : ''}
				</div>
			</div>
		)
	}

	const DMSSettingRender = (dmsSetting) => {
		const { name, event_setting, event_type_name, isInternal, description, voice_prompt_setting } = dmsSetting
		// FWSD-7044
		const onToggleClick = (e) => {
			if (e.target.name === 'Event.Dms.Seatbelt.Enabled' && e.target.checked) {
				setShowModalDMSSeatbeltToggle({
					function: () => {
						if (!isDV4) {
							fillForm({ target: { name: e.target.name, checked: true } }, settingsType)
						} else {
							fillFormBoolean({ target: { name: e.target.name, checked: true } }, settingsType)
						}
						setShowModalDMSSeatbeltToggle(false)
					}
				})
			}
			// FWSD-7081
			else if (e.target.name === 'Event.Dms.Dozing.Enabled') {
				fillFormBoolean({ target: { name: 'Event.Dms.HeadDown.Enabled', checked: e.target.checked } }, settingsType)
				if (!isDV4) {
					fillForm({ target: { name: 'Event.Dms.Dozing.Enabled', checked: e.target.checked } }, settingsType)
				} else {
					fillFormBoolean({ target: { name: 'Event.Dms.Dozing.Enabled', checked: e.target.checked } }, settingsType)
				}
			}
			else {
				if (!isDV4) {
					fillForm(e, settingsType)
				}
				else {
					fillFormBoolean(e, settingsType)
				}
			}
		}

		const onSensitivityClick = (e, ...arg) => {
			if (e.target.name === 'Event.Dms.Dozing.Sensitivity') {
				props.fillForm({ target: { name: 'Event.Dms.Dozing.Sensitivity', checked: e.target.checked } }, ...arg)
				props.fillForm({ target: { name: 'Event.Dms.HeadDown.Sensitivity', checked: e.target.checked } }, ...arg)
			}
			else {
				props.fillForm(e, ...arg)
			}
		}

		if (isInternal && !isInternalUser(userRole)) {
			return <div key="empty" />
		}
		else {
			return (
				<div key={name} className="settings-card">
					<div className="card-header">
						<div>
							DMS - {name}
							{isDV4 && <span className="subtitle">{t('subtitleRequires')}</span>}
							{isInternal && <LabelTag text={t('textInternal')} tag_type='ml-10 internal' />}
						</div>
						<Toggle
							name={`Event.Dms.${event_setting}.Enabled`}
							checked={_.get(currentConfig, `Event.Dms.${event_setting}.Enabled`)}
							icons={false}
							// onChange={(e) => fillFormBoolean(e, settingsType)}
							onChange={onToggleClick}
						/>
					</div>
					<div className="card-body">
						<p>{description}</p>
						{/* anumation of card-body content displaing with delay 0.5s */}
						<div className={`${!currentConfig.Event.Dms[event_setting].Enabled ? 'hide' : ''}`}>
							<SelectionEventVideoType
								name={event_type_name}
								value={event_types[event_type_name]}
								setEventTypes={setEventTypes}
								labelPosition="top"
							/>
							{!isDV4 && (event_setting === "Seatbelt" || event_setting === "Distraction") &&
								<SelectionSoundType
									name={event_setting}
									value={currentConfig.System.Chimes[event_setting]}
									setSoundTypes={setSoundTypes}
								/>}

							{!isDV4 &&
								<>
									{(event_setting !== "Seatbelt" && event_setting !== "Distraction") &&
										<div className="toggle-wrapper">
											<label className="settings-title">{t('titleEventVoicePrompt')}</label>
											<div>
												<Toggle
													name={voice_prompt_setting}
													checked={_.get(currentConfig, voice_prompt_setting, '')}
													icons={false}
													onChange={(e) => fillFormBoolean(e, settingsType)}
												/>
												<SoundPlayButton soundKeyName={event_setting} iconButton value={_.get(currentConfig, voice_prompt_setting, '') ? 1 : 0} />
											</div>
										</div>}

									<div className="toggle-wrapper button-group">
										<label className="settings-title">{t('settingsTitleSensitivity')}</label>
										<div className="button-group">
											<CustomButton
												variant="toggle-group"
												active={(+_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`) === -1)}
												name={`Event.Dms.${event_setting}.Sensitivity`}
												// onClick={(e) => props.fillForm(e, true, '', -1)}
												onClick={(e) => onSensitivityClick(e, true, '', -1)}
											>
												{t('btnLessSensitive')}
											</CustomButton>
											<CustomButton
												variant="toggle-group"
												active={(+_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`) === 0)}
												name={`Event.Dms.${event_setting}.Sensitivity`}
												// onClick={(e) => props.fillForm(e, true, '', 0)}
												onClick={(e) => onSensitivityClick(e, true, '', 0)}
											>
												{t('btnDefault')}
											</CustomButton>
											<CustomButton
												variant="toggle-group"
												active={(+_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`) === 1)}
												name={`Event.Dms.${event_setting}.Sensitivity`}
												// onClick={(e) => props.fillForm(e, true, '', 1)}
												onClick={(e) => onSensitivityClick(e, true, '', 1)}
											>
												{t('btnMoreSensitive')}
											</CustomButton>
										</div>
									</div>
								</>
							}
						</div>
					</div>
				</div>
			)
		}
	}

	const ADASSettingRender = (adasSetting) => {
		const { name, event_setting, event_type_name, description, voice_prompt_setting, sliderObj } = adasSetting
		return (
			<div key={name} className="settings-card">
				<div className="card-header">
					<div>
						ADAS - {name}
						{isDV4 && <span className="subtitle">{t('adasSubtitleRequires')}</span>}
					</div>
					<Toggle
						name={`Event.Adas.${event_setting}.Enabled`}
						checked={currentConfig.Event.Adas[event_setting]?.Enabled}
						icons={false}
						onChange={(e) => !isDV4 ? fillForm(e, settingsType) : fillFormBoolean(e, settingsType)}
					/>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{/* anumation of card-body content displaing with delay 0.5s */}
					<div className={`${!currentConfig.Event.Adas[event_setting]?.Enabled ? 'hide' : ''}`}>
						{!isDV4 &&
							<>
								<SelectionEventVideoType
									name={event_type_name}
									value={event_types[event_type_name]}
									setEventTypes={setEventTypes}
								/>
								<SelectionSoundType
									name={event_setting}
									value={
										event_setting === "ForwardCollision" ?
											+currentConfig.System.Chimes.ForwardCollision :
											currentConfig.System.Chimes[event_setting]
									}
									setSoundTypes={setSoundTypes}
									{...(event_setting === "ForwardCollision" && {
										customSoundsOptions: [
											{
												value: "0",
												label: i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.disableAudio')
											},
											{
												value: "1",
												label: i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.eventChime')
											},
										]
									})}
								/>
								{['TrafficLightViolation', 'StopSignViolation'].includes(event_setting) && eventDistanceTimeRender(sliderObj)}
							</>
						}
					</div>
				</div>
			</div>
		)
	}

	const dvSensitivitySettingRender = (sensitivitySetting) => {
		const { name, event_setting, event_type_name, description, sliderObj, sublabel, voice_prompt_setting } = sensitivitySetting
		return (
			<div key={name} className="settings-card">
				<div className="card-header">
					<div>
						{name}
						{sublabel && <span className="sublabel">{sublabel}</span>}
					</div>

					<Toggle
						name={`Event.${event_setting}.Enabled`}
						checked={currentConfig.Event[event_setting].Enabled}
						icons={false}
						onChange={(e) => fillFormBoolean(e, settingsType)}
					/>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{/* animation of card-body content displaing with delay 0.5s */}
					<div className={`${!currentConfig.Event[event_setting].Enabled ? 'hide' : ''}`}>
						{/* Upload Type */}
						<SelectionEventVideoType
							name={event_type_name}
							value={event_types[event_type_name]}
							setEventTypes={setEventTypes}
						/>
						{!isDV4 && !['Accelerometer', 'BackUpWarning'].includes(event_setting) &&
							<>
								<SelectionSoundType
									name={event_setting}
									value={currentConfig.System.Chimes[event_setting]}
									setSoundTypes={setSoundTypes}
								/>
							</>}
						{/* Event Chime */}
						{!!isDV4 || (event_setting === "Accelerometer") &&
							<div className="toggle-wrapper">
								<label
									className="settings-title">{event_setting === 'Accelerometer' ? t('titleEventChime') : t('titleEventVoicePrompt')}</label>

								<div>
									<Toggle
										name={`System.Chimes.${event_setting}`}
										checked={currentConfig.System.Chimes[event_setting]}
										icons={false}
										onChange={(e) => fillFormBoolean(e, settingsType)}
									/>
									<SoundPlayButton soundKeyName={event_setting} iconButton value={currentConfig.System.Chimes[event_setting] ? 2 : 0} />
								</div>
							</div>}
						{/* Sound Type */}
						{['BackUpWarning'].includes(event_setting) && (
							<div className="toggle-wrapper">
								<label className="settings-title">{t('titleEventVoicePrompt')}</label>
								<div>
									<Toggle
										name={voice_prompt_setting}
										checked={_.get(currentConfig, voice_prompt_setting, '')}
										icons={false}
										onChange={(e) => {
											const value = e.target.checked;
											fillFormBoolean(e, settingsType, null, +value)
										}}
									/>
									<SoundPlayButton iconButton value={_.get(currentConfig, voice_prompt_setting, '') ? 1 : 0} />
								</div>
							</div>
						)}
						{/* Sensitivity */}
						{!['BackUpWarning'].includes(event_setting) && eventSensitivityRender(sliderObj)}
					</div>
				</div>
			</div>
		)
	}

	const dv7BlindSpotRender = (blindSpotsSettings) => {
		const { name, description, settings } = blindSpotsSettings;

		return (
			<div className="settings-card">
				<div className="card-header">
					<div>
						{name}
					</div>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{settings.map(item => {
						const { name, event_setting, event_sub_setting, event_type_name } = item;

						return (
							<React.Fragment key={event_type_name}>
								<ul className="blind-spot-list">
									<li>
										<div>
											<div>{name}</div>
											<Toggle
												name={`Event.${event_setting}.${event_sub_setting}.Enabled`}
												checked={currentConfig.Event[event_setting][event_sub_setting].Enabled}
												icons={false}
												onChange={(e) => fillFormBoolean(e, settingsType)}
											/>
										</div>
									</li>
								</ul>
								<SelectionEventVideoType
									name={event_type_name}
									value={event_types[event_type_name]}
									setEventTypes={setEventTypes}
								/>
								<div className="toggle-wrapper">
									<label
										className="settings-title">{t('titleEventChime')}</label>

									<div>
										<Toggle
											name={`System.Chimes.${event_setting}.${event_sub_setting}`}
											checked={currentConfig.System.Chimes[event_setting][event_sub_setting]}
											icons={false}
											onChange={(e) => {
												const checked = e.target.checked;
												const value = checked ? 2 : 0;
												fillFormBoolean(e, settingsType, null, value)
											}}
										/>
										<SoundPlayButton iconButton value={currentConfig.System.Chimes[event_setting][event_sub_setting] ? 2 : 0} />
									</div>
								</div>
							</React.Fragment>
						)
					})}
				</div>
			</div>
		)
	}

	const dv7SpeedLimitRender = (speedLimitSettings) => {
		const { name, description, settings } = speedLimitSettings;

		return (
			<div className="settings-card">
				<div className="card-header">
					<div>
						{name}
					</div>
				</div>
				<div className="card-body">
					<p>{description}</p>
					<ul>
						<li><span>{t('speedingNoPromptLabel')}</span> - {t('speedingNoPrompt')}</li>
						<li><span>{t('speedingOnePromptLabel')}</span> - {t('speedingOnePrompt')}</li>
						<li><span>{t('speedingContinuousPromptLabel')}</span> - {t('speedingContinuousPrompt')}</li>
					</ul>
					<div className="configs-container">
						{settings.map(item => {
							const { name, event_setting, event_sub_setting, event_type_name } = item;

							return (
								<div className="speed-config">
									<div className="config-toggle">
										<div>{name}</div>
										<Toggle
											name={`Event.${event_setting}.${event_sub_setting}.Enabled`}
											checked={currentConfig.Event[event_setting][event_sub_setting].Enabled}
											icons={false}
											onChange={(e) => fillFormBoolean(e, settingsType)}
										/>
									</div>
									<SelectionEventVideoType
										name={event_type_name}
										value={event_types[event_type_name]}
										setEventTypes={setEventTypes}
									/>
									{event_sub_setting === 'Low' ? (
										<div className="toggle-wrapper">
											<label
												className="settings-title">{t('titleEventChime')}</label>

											<div>
												<Toggle
													name={`System.Chimes.${event_setting}.${event_sub_setting}`}
													checked={currentConfig.System.Chimes[event_setting][event_sub_setting]}
													icons={false}
													onChange={(e) => {
														const checked = e.target.checked;
														const value = checked ? 2 : 0;
														fillFormBoolean(e, settingsType, null, value)
													}}
												/>
												<SoundPlayButton iconButton value={currentConfig.System.Chimes[event_setting][event_sub_setting] ? 2 : 0}/>
											</div>
										</div>
									) : (
										<SelectionSoundType
											name={event_setting}
											subType={event_sub_setting}
											value={currentConfig.System.Chimes[event_setting][event_sub_setting]}
											setSoundTypes={setSoundTypes}
										/>
									)}
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}

	return (
		<main className="event-settings main-content-block">
			<h3 className="category-title">{t('titleEventSettings')}</h3>
			<div className="category-subheader">
				{t('subheaderEventSettings')}
			</div>

			<div className="settings-card">
				<div className="card-header">
							{t('headerDriverEvent')}
							<Toggle
								name={!isDV4 ? "Enabled" : "Event.PanicButton.Enabled"}
								checked={!isDV4 ? Sensor4.Enabled : currentConfig.Event.PanicButton?.Enabled}
								icons={false}
								onChange={(e) => {
									!isDV4 ? fillFormSensors(e, 4) : fillFormBoolean(e, settingsType)
								}}
							/>
						</div>
						<div className="card-body">
							<p>{t('bodyDriverEvent')}</p>
							{/* anumation of card-body content displaing with delay 0.5s */}
							<div
								className={`${(!isDV4 && !Sensor4.Enabled) || (isDV4 && !currentConfig.Event.PanicButton?.Enabled) ? 'hide' : ''}`}>
								<SelectionEventVideoType
									name={isDV6 ? "dv6_driver" : isDV7 ? "dv7_driver" : "dv4_driver"}
									value={isDV6 ? event_types.dv6_driver : isDV7 ? event_types.dv7_driver : event_types.dv4_driver}
									setEventTypes={setEventTypes}
								/>
							</div>
						</div>
					</div>

					{isDV4 &&
						<div className="settings-card">
							<div className="card-header">
								{t('headerExternalDriverEvent')}
								<Toggle
									name="Enabled"
									checked={Sensor4.Enabled}
									icons={false}
									onChange={(e) => fillFormSensors(e, 4)}
								/>
							</div>
							<div className="card-body">
								<p>{t('bodyExternalDriverEvent')}</p>
								{/* anumation of card-body content displaing with delay 0.5s */}
								<div className={`${!Sensor4.Enabled ? 'hide' : ''}`}>
									<SelectionEventVideoType
										name="dv4_ext_driver"
										value={event_types.dv4_ext_driver}
										setEventTypes={setEventTypes}
									/>
								</div>
							</div>
						</div>
					}

					<div className="settings-card">
						<div className="card-header">
							{t('headerMaxSpeed')}
							<Toggle
								name="Event.HighSpeed.Enabled"
								checked={currentConfig.Event.HighSpeed.Enabled}
								icons={false}
								onChange={(e) => fillFormBoolean(e, settingsType)}
							/>
						</div>
						<div className="card-body">
							<p>{t('bodyMaxSpeed')}</p>
							{/* anumation of card-body content displaing with delay 0.5s */}
							<div className={`${!currentConfig.Event.HighSpeed.Enabled ? 'hide' : ''}`}>
								<SelectionEventVideoType
									name={isDV6 ? "dv6_high_speed" : isDV7 ? "dv7_high_speed" : "dv4_high_speed"}
									value={isDV6 ? event_types.dv6_high_speed : isDV7 ? event_types.dv7_high_speed : event_types.dv4_high_speed}
									setEventTypes={setEventTypes}
								/>
								{!isDV4 &&
									<SelectionSoundType
										name={"HighSpeed"}
										value={currentConfig.System.Chimes.HighSpeed}
										setSoundTypes={setSoundTypes}
									/>}
								<div className="toggle-wrapper button-group">
									<label className="settings-title">{t('titleMaxSpeedThreshold')}</label>
									<div>
										<input
											type="number"
											step="1"
											min="0"
											max="1000"
											maxLength="4"
											value={(currentConfig.System.SpeedUnit === 2) ? currentConfig.Event.HighSpeed.Threshold : (currentConfig.Event.HighSpeed.Threshold / 1.609344).toFixed(0)}
											className="vehicle-search number-input mr-10 pt-5"
											name="Event.HighSpeed.Threshold"
											onChange={(e) => fillForm(e, settingsType)}
										/>
										<label
											style={{marginLeft: '6px'}}>{currentConfig.System.SpeedUnit === 2 ? 'KPH' : 'MPH'}</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					{isDV7 && dv7BlindSpotRender(blindSpotsSettings)}
					{isDV7 && dv7SpeedLimitRender(speedLimitSettings)}

					{!isDV4 ? (
						<>
							{/* DV6 Sensitivity  */}
							{isDV6 && dv6SensitivitySettings.map((item) => dvSensitivitySettingRender(item))}
							{/* DV7 Sensitivity  */}
							{isDV7 && dv7SensitivitySettings.map((item) => dvSensitivitySettingRender(item))}

							{/* DV6 ADAS  */}
							{isDV6 && (dv6ADASSettings.map((item) => ADASSettingRender(item)))}
							{/* DV7 ADAS  */}
							{isDV7 && (dv7ADASSettings.map((item) => ADASSettingRender(item)))}

							<div className="settings-card">
								<div className="card-header">
									{t('headerADAS')}
								</div>
								<div className="card-body">
									<p>{t('bodyADAS')}</p>
									{/* ToDo: Refactor it. Add eventDistanceTimeRender instead of <div className="toggle-wrapper slider-wrapper block"> here */}
									<div className="toggle-wrapper slider-wrapper block">
										<label
											className="settings-title mb-10">{t('titleFollowingDistanceTime')}</label>
										<div className="toggle-wrapper slider-wrapper p-0 no-border">
											<div className="backlight-slider mr-20">
												<CustomReactBootstrapSlider
													max={3.0}
													min={0.1}
													step={0.1}
													tooltip="show"
													value={+currentConfig.Event.Adas.Headway.Ttc.TriggerThreshold}
													change={(e) => fillForm(e, settingsType, 'Event.Adas.Headway.Ttc.TriggerThreshold')}
												/>
												<InfoPop
													title={t('infoPopTitle')}
													body={t('infoPopBody')}
													placement='top'
												>
													<div className="temp-bar-container slider slider-horizontal mt-10">
														<div className="cold temp-bar">{t('tempBarLessSensitive')}</div>
														<div className="med temp-bar"/>
														<div className="hot temp-bar">{t('tempBarMoreSensitive')}</div>
													</div>
												</InfoPop>
											</div>
											<div>
												<input
													type="number"
													step="0.1"
													min="0.1"
													max="3.0"
													maxLength="3"
													name="Event.Adas.Headway.Ttc.TriggerThreshold"
													value={currentConfig.Event.Adas.Headway.Ttc.TriggerThreshold}
													className="vehicle-search number-input mr-10 pt-5"
													onChange={(e) => fillForm(e, settingsType)}
												/>
												<label style={{marginLeft: '6px'}}>{t('textSeconds')}</label>
											</div>
										</div>
									</div>

									<div className="toggle-wrapper slider-wrapper block">
										<label className="settings-title mb-10">{t('titleMinimumSpeed')}</label>
										<div className="toggle-wrapper slider-wrapper p-0 no-border">
											<div className="slider-wrapper header-slider">
												<div className="slider-minmax-value min-value">
													{`${getMinSpeedSlider()} ${currentConfig.System.SpeedUnit === 1 ? 'MPH' : 'KPH'}`}
												</div>
												<CustomReactBootstrapSlider
													min={getMinSpeedSlider()}
													max={getMaxSpeedSlider()}
													step={1}
													tooltip="show"
													value={numberFormat()}
													change={(e) => onMinimumSpeedChange(e.target.value)}
												/>
												<div className="slider-minmax-value max-value">
													{`${getMaxSpeedSlider()} ${currentConfig.System.SpeedUnit === 1 ? 'MPH' : 'KPH'}`}
												</div>
											</div>
											<div>
												<input
													type="number"
													step="1"
													min={getMinSpeedSlider()}
													max={getMaxSpeedSlider()}
													maxLength="3"
													name="Event.Adas.Headway.SpeedThreshold"
													value={numberFormat()}
													className="vehicle-search number-input mr-10 pt-5"
													onChange={(e) => onMinimumSpeedChange(e.target.value)}
												/>
												<label
													style={{marginLeft: '6px'}}>{currentConfig.System.SpeedUnit === 1 ? 'MPH' : 'KPH'}</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							{isDV7 && (dv7ADASSettingsPart2.map((item) => ADASSettingRender(item)))}

							{/* DV6 DMS  */}
							{isDV6 && dv6DMSSettings.map((item) => DMSSettingRender(item))}
							{/* DV7 DMS  */}
							{isDV7 && dv7DMSSettings.map((item) => DMSSettingRender(item))}

							<div className="settings-card">
								<div className="card-header">
									{t('cardHeaderPotentialCh2')}
									<Toggle
										name="Event.Dms.CameraObstruction.Enabled"
										checked={currentConfig.Event.Dms.CameraObstruction.Enabled}
										icons={false}
										onChange={(e) => !isDV4 ? fillForm(e, settingsType) : fillFormBoolean(e, settingsType)}
									/>
								</div>
								<div className="card-body">
									<p>{t('cardBodyPotentialCh2')}</p>
									<div
										className={`${!currentConfig.Event.Dms.CameraObstruction.Enabled ? 'hide' : ''}`}>
										<ul>
											<li><b>{t('titleNoPrompt')}</b> - {t('descriptionNoPrompt')}</li>
											<li><b>{t('titleSingleChime')}</b> - {t('descriptionSingleChime')}</li>
											<li><b>{t('titleContinuousChime')}</b> - {t('descriptionContinuousChime')}
											</li>
											<li><b>{t('titleSinglePrompt')}</b> - {t('descriptionSinglePrompt')}</li>
											<li><b>{t('titleContinuousPrompt')}</b> - {t('descriptionContinuousPrompt')}
											</li>
										</ul>

										<SelectionEventVideoType
											name={isDV6 ? "dv6_camera_block" : "dv7_camera_block"}
											value={isDV6 ? event_types.dv6_camera_block : event_types.dv7_camera_block}
											setEventTypes={setEventTypes}
										/>

										<SelectionSoundType
											name="CameraObstruction"
											value={currentConfig.System.Chimes.CameraObstruction.SoundType}
											setSoundTypes={setSoundTypes}
										/>

										{!!currentConfig.System.Chimes.CameraObstruction.SoundType && (
											<div className="toggle-wrapper">
												<label
													className="settings-title">{t('cardHeaderVoicePromptFrequency')}</label>
												<div>
													<span className="subtitle mr-5">{t('textSingle')}</span>
													<Toggle
														name="System.Chimes.CameraObstruction.Enabled"
														checked={currentConfig.System.Chimes.CameraObstruction.Enabled === 2}
														icons={false}
														onChange={(e) => fillForm(e, settingsType)}
													/>
													<span className="subtitle">{t('textContinuous')}</span>
												</div>
											</div>)}
									</div>
								</div>
							</div>
						</>
					) : (
						<>
							{/* DV4 ADAS  */}
							{dv4ADASSettings.map((item) => ADASSettingRender(item))}

							<div className="settings-card">
								<div className="card-header">
									<div>
										{t('titleSpeedWarning')}
										<span className="subtitle">{t('subtitleRequiresMobileye')}</span>
									</div>
									<select
										placeholder="select"
										className="rosco-select"
										name="Event.Adas.SpeedThreshold"
										onChange={(e) => fillFormInt(e, settingsType)}
										value={currentConfig.Event.Adas.SpeedThreshold}
									>
										<option value="0">{t('textLevel')} 0 +[0 {unit}]</option>
										<option value="1">{t('textLevel')} 1 +[0-5 {unit}]</option>
										<option value="2">{t('textLevel')} 2 +[5-10 {unit}]</option>
										<option value="3">{t('textLevel')} 3 +[10-15 {unit}]</option>
										<option value="4">{t('textLevel')} 4 +[15-20 {unit}]</option>
										<option value="5">{t('textLevel')} 5 +[20-25 {unit}]</option>
										<option value="6">{t('textLevel')} 6 +[25-30 {unit}]</option>
										<option value="7">{t('textLevel')} 7 +[30-35 {unit}]</option>
										<option value="8">{t('textLevel')} 8 +[35 {unit}]</option>
									</select>
								</div>
								<div className="card-body">
									<p>{t('bodySpeedWarning')}</p>
								</div>
							</div>

							{/* DV4 DMS  */}
							{dv4DMSSettings.map((item) => DMSSettingRender(item))}
						</>
					)}

					{showModalDMSSeatbeltToggle &&
						<ModalDelete
							title={t('modalDeleteTitle')}
							content={t('modalDeleteContent')}
							showClose
							deleteBtnName={t('deleteBtnName')}
							closeBtnName={t('closeBtnName')}
							styleView="primary"
							backdropClassName="upper"
							closeModal={() => {
								setShowModalDMSSeatbeltToggle(false)
							}}
							deleteModal={showModalDMSSeatbeltToggle.function}
						/>
					}
				</main>
				)
				}

				export default FleetConfigurationEvent;
